"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinancialModal = exports.FinacialField = void 0;
var _translation = _interopRequireDefault(require("../Translation/translation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FinancialModal = (lang, translations) => ({
  baloise: {
    terms: {
      title: 'Help me with these terms',
      text: `
            <h3 class="mb-2 fweight-600 fsize-400">
                ${(0, _translation.default)('What is the equity capital?', lang, undefined, translations)}
            </h3>
            <p class="pb-3">
                ${(0, _translation.default)('This is the money you can contribute to the mortgage. It may come from savings, private pensions, occupational pension funds, inheritance etc. Lenders generally require a deposit of at least 20% of the price.', lang, undefined, translations)}
            </p>
            <h3 class="mb-2 fweight-600 fsize-400">
               ${(0, _translation.default)('What is the net annual income?', lang, undefined, translations)}
            </h3>
            <p class="pb-3">
                ${(0, _translation.default)('The net income is the gross income minus social security contributions and regular expenses such as instalments for leasing obligations, personal loans or alimony. If you have only the gross income, you can deduct 15% from it.', lang, undefined, translations)}
            </p>`
    }
  },
  default: {
    affordability: {
      title: 'Affordability',
      text: `
        <p class="hello">
            ${(0, _translation.default)('This provides an indication of whether you can afford your preferred mortgage in the medium term. Generally, the sum of the mortgage rates, the amortisation, the maintenance and ancillary costs should not add up to more than a third of your income. The calculation is based on a notional mortgage rate of 5%', lang, undefined, translations)}
        </p>`
    },
    ratio: {
      title: 'Loan-to-value ratio',
      text: `
        <p>
            ${(0, _translation.default)('The loan-to-value-ratio refers to the proportion of the price that will be financed by a mortgage. Most lenders offer mortgages up to a maximum loan-to-value ratio of 80%.', lang, undefined, translations)}</p><p>${(0, _translation.default)('Example: If the price is CHF 1\'000\'000 and you get a mortgage for CHF 600\'000, the loan-to-value ratio is 60%.', lang, undefined, translations)}
        </p>`
    },
    terms: {
      title: 'Help me with these terms',
      text: `
            <h3 class="mb-2 fweight-600 fsize-400">
                ${(0, _translation.default)('What is the equity capital?', lang, undefined, translations)}
            </h3>
            <p class="pb-3">
                ${(0, _translation.default)('This is the money you can contribute to the mortgage. It may come from savings, private pensions, occupational pension funds, inheritance etc. Lenders generally require a deposit of at least 20% of the price.', lang, undefined, translations)}
            </p>
            <h3 class="mb-2 fweight-600 fsize-400">
               ${(0, _translation.default)('What is the gross annual income?', lang, undefined, translations)}
            </h3>
            <p class="pb-3">
                ${(0, _translation.default)('This is the income of your household before deduction of social contributions, including 13th month salary and other salary components (e.g. bonuses).', lang, undefined, translations)}
            </p>`
    }
  }
});
exports.FinancialModal = FinancialModal;
const FinacialField = exports.FinacialField = {
  income: {
    baloise: {
      name: 'netIncome',
      label: 'Your net annual income',
      placeholder: 'Net annual income',
      errorMsg: 'Your net annual income cannot be 0'
    },
    default: {
      name: 'grossIncome',
      label: 'Your gross annual income',
      placeholder: 'Gross annual income',
      errorMsg: 'Your gross annual income cannot be 0'
    }
  }
};